<template>
    <card class="card-plain">
        <div v-if="customer && $auth.hasAnyOfRoles(['admin'])" class="card-body row pt-0">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-6">
                        <el-card shadow="always" class="mt-4">
                            <legend class="pr-2 pl-2 license-information-label">{{$t('License information')}}</legend>
                            <h6 class="mt-2 p-4 license-information-text">{{`${$t('User limit')}: ${customer.settings.contract.userLimit}`}}</h6>
                            <h6 class="p-4 license-information-text">{{`${$t('Package')}: ${customer.settings.contract.packageType}`}}</h6>
                        </el-card>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer pb-0 pt-4">
            <p class="info-content">Du nutzt
TeamWave, Version 1.1.3
von:

WeGenics GmbH, Äußere Ragnitz 83 c/1, A-8047 Kainbach bei Graz
FN 527090h, GISA 32472974


Du erreichst uns zu folgenden Anliegen unter:

1. Die <b>Allgemeinen Geschäftsbedingungen</b> und die <b>DSGVO Richtlinie</b> findest Du unter: <a href="https://teamwave.at">https://teamwave.at</a>
2. Für <b>Produktanfragen</b> und <b>Informationen</b> zu TeamWave wende Dich an: <a href="mailto:office@teamwave.at">office@teamwave.at</a>
3. Bei <b>technischen Probleme</b> mit dem Produkt TeamWave wende Dich an unseren Mail-Support: <a href="mailto:support@teamwave.at">support@teamwave.at</a>
4. Bei <b>technischen Notfällen</b> kontaktiere Deinen unternehmensinternen Admin. Er/Sie verfügt über die vertraglich vereinbarten Notfallkontaktdaten einer Soforthilfe. 
5. Möchtest Du uns <b>Feedback zu TeamWave</b> geben oder uns Deine Erfahrungen mitteilen, nütze dazu unsere Feedbackfunktion. Den Button dazu findets Du auf jeder TeamWave-Seite rechts oben neben dem Logout Button.


Wir wünschen Dir viel Freude bei der Anwendung und Nutzung von TeamWave.

Dein TeamWave Team!</p>
        </div>
    </card>
</template>

<script>
    import { Card } from 'element-ui'
    import { CustomerRecord } from '../../../../store/models/Customer'

    export default {
        name: 'Info',
        components: {
            [Card.name]: Card
        },
        data () {
            return {
                customer: null,
                loading: false,
            }
        },
        mounted () {
            this.init()
        },
        methods: {
            async init () {
                await this.fetch()
            },
            async fetch () {
                try {
                    this.loading = true
                    const result = await CustomerRecord.api().get(`/customer`, { save: false })
                    this.customer = new CustomerRecord(result.response.data)
                } catch (e) { console.log('e', e)} finally {
                    this.loading = false
                }
            }
        }
    }
</script>

<style lang="scss">
    .license-information-label {
        position: absolute;
        width: auto;
        top: 5px;
        background-color: #ffffff;
    }

    .license-information-text {
        text-transform: capitalize;
        font-weight: normal;
    }

    .info-content {
        white-space: pre-line;
    }
</style>
